var React = require('react');

function BlueQuote (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"â","d":"M9.77203 12L13.5582 0H18L15.6099 12H9.77203ZM0 12L4.03995 0H8.46063L6.04935 12H0Z","fill":"#008c95"}));
}

BlueQuote.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = BlueQuote;

BlueQuote.default = BlueQuote;
